import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'

export function initSentry () {
  Sentry.init({
    dsn: 'https://5b9fd17eb6154a7496942ac0bce59502@o550214.ingest.sentry.io/5673552',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}